module.exports = __webpack_public_path__ + "static/media/wavinge4f8197e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/waving.svg
// module id = 1347
// module chunks = 0